import * as Actions from 'store/actions/app/treasury_movements.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_treasury_movements: false,
  treasury_movements: [],

  saving_treasury_movement: false,
  saved_treasury_movement: false,

  voiding_treasury_movement_ids: [],
  voided_treasury_movement_ids: [],
}

export default function treasuryMovementsReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_TREASURY_MOVEMENTS: {
      return {
        ...state,
        loading_treasury_movements: action.payload.loading,
        treasury_movements: action.payload.data ?? state.treasury_movements,
      }
    }
    case Actions.SAVE_TREASURY_MOVEMENT: {
      return {
        ...state,
        saving_treasury_movement: action.payload.saving ?? state.saving_treasury_movement,
        saved_treasury_movement: action.payload.saved ?? false,
        treasury_movements: action.payload.data
          ? addOrUpdateObjectInArray(state.treasury_movements, action.payload.data, 'movimiento_tesoreria_id')
          : state.treasury_movements,
      }
    }
    case Actions.VOID_TREASURY_MOVEMENT: {
      return {
        ...state,
        voiding_treasury_movement_ids: toggleIdInArray(state.voiding_treasury_movement_ids, action.payload.voiding_id),
        voided_treasury_movement_ids: toggleIdInArray(state.voided_treasury_movement_ids, action.payload.voided_id),
        treasury_movements: action.payload.data
          ? addOrUpdateObjectInArray(state.treasury_movements, action.payload.data, 'movimiento_tesoreria_id')
          : state.treasury_movements,
      }
    }
    default: {
      return state
    }
  }
}
